import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './CalendarItem.scss'


class CalendarItem extends Component {

  static propTypes = {
    date: PropTypes.number.isRequired,
    initialDate: PropTypes.object.isRequired,
    isToday: PropTypes.bool,
    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isInCurrentMonth: PropTypes.bool,
    onDateSelect: PropTypes.func.isRequired,
  }

  handleClick = () => {
    const { onDateSelect, initialDate } = this.props

    onDateSelect(initialDate)
  }

  render() {
    const { date, isSelected, isToday, isInCurrentMonth, isDisabled } = this.props

    const className = cx(s.main, {
      [s.today]: isToday,
      [s.selected]: isSelected,
      [s.disabled]: isDisabled,
      [s.inMonth]: isInCurrentMonth,
    })

    return (
      <div className={className} onClick={isDisabled ? null : this.handleClick}>
        {date}
      </div>
    )
  }
}


export default CalendarItem
